import { render, staticRenderFns } from "./SellerSelection.vue?vue&type=template&id=12fb34f1&"
import script from "./SellerSelection.vue?vue&type=script&lang=js&"
export * from "./SellerSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports